import * as Papa from 'papaparse';

export const hasValue = (x: any) => <boolean>x;

export function mergeArrays<T = any, P = any>(
    arrays: Array<Array<T>>,
    mergeFn: (values?: Array<T>, index?: number, sources?: Array<Array<T>>) => P
): Array<P> {
    let maxLength = Math.max(...arrays.map(arr => arr.length));
    let result = new Array<P>(maxLength);
    for (let i = 0; i < maxLength; i++) {
        let actualArrays = arrays.filter(arr => arr.length > i);
        result[i] = mergeFn(
            actualArrays.map(arr => arr[i]),
            i,
            actualArrays
        );
    }
    return result;
}

export function arrayToCsv(array: string[][], separator: string = ','): string {
    if (!array) {
        return '';
    }

    return Papa.unparse(array, {
        skipEmptyLines: 'greedy',
        quoteChar: '"',
        delimitersToGuess: [',', '\t', '|', ';', Papa.RECORD_SEP, Papa.UNIT_SEP],
    });
}
